import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';
import bg from '../../../../Assets/images/Background.jpg';

export const useStyles = makeStyles((theme: Theme) => ({
  heroSection: {
    width: '100%',
    minHeight: '100vh',
    background: `url(${bg}), radial-gradient(80% 70% at center top, #262866 0%, #1f2150 40%, #121234 70%, #0a0a1f 100%)`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundAttachment: 'scroll',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    overflow: 'hidden',
    padding: '6vh 0 3vh 0',
    [theme.breakpoints.down('md')]: {
      padding: '4vh 0',
      background: `radial-gradient(80% 70% at center top, #262866 0%, #1f2150 40%, #121234 70%, #0a0a1f 100%)`,
    },
  },
  SubmitNowBtn: {
    display: 'flex',
    // background: 'linear-gradient(180deg, rgba(55, 38, 18, 0.00) -175%, rgba(255, 133, 11, 0.50) 140%), #B73601',
    backgroundColor: 'white',
    padding: '0.8vh 2vh !important',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '0.8vh',
    cursor: 'pointer',
    fontSize: '1.4vh !important',
    borderRadius: '1.2vh !important',
    border: '1px solid #FFF',
    boxShadow: '0px 1px 2px 0px #FA854D, 0px 0px 0px 3px rgba(255, 181, 114, 0.16)',
    color: 'rgba(183, 54, 1, 1) !important',
    [theme.breakpoints.down('lg')]: {
      padding: '0.8vh 1.2vh !important',
      fontSize: '1.2vh !important',
      borderRadius: '1.4vh !important',
    },
  },

  flexJust: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '20px',
  },

  contentWrapper: {
    maxWidth: '100%',
    maxHeight: '90vh',
    padding: '0 20px',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    color: '#fff',
    [theme.breakpoints.down('md')]: {
      maxHeight: '200vh',
      marginBottom: '10vh',
    },
  },
  logoRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '2vh',
    flexWrap: 'wrap',
    marginBottom: '4vh',
    willChange: 'transform',
  },
  logoImage: {
    height: '4vh',
    objectFit: 'contain',
    cursor: 'pointer',
    imageRendering: 'crisp-edges',
    [theme.breakpoints.down('md')]: {
      height: '3.5vh',
    },
  },
  divider: {
    height: '6vh',
    width: '0.05vw',
    backgroundColor: '#BBBBBB',
    willChange: 'transform',
    cursor: 'pointer',
    transform: 'translateZ(0)',
    [theme.breakpoints.down('md')]: {
      height: '5vh',
    },
  },
  zeeLogo: {
    height: '5vh',
    objectFit: 'contain',
    imageRendering: 'crisp-edges',
  },
  datePillContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '0.8vh',
    padding: '1vh 1.8vh',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50px',
    background: 'linear-gradient(0deg, rgba(52, 27, 27, 0.30) 0%, rgba(52, 27, 27, 0.30) 100%), linear-gradient(180deg, rgba(255, 255, 255, 0.16) 0%, rgba(255, 255, 255, 0.16) 100%)',
    boxShadow: '0px 2px 2px 0px rgba(183, 54, 1, 0.55), 0px 0px 0px 3px rgba(183, 54, 1, 0.17) !important',
    marginBottom: '3vh',
    willChange: 'transform',
    transform: 'translateZ(0)',
    [theme.breakpoints.down('md')]: {
      background: 'none',
      boxShadow: 'none !important',
    },
  },
  datePill: {
    background: 'linear-gradient(180deg, rgba(55, 38, 18, 0.00) -175%, rgba(255, 133, 11, 0.50) 140%), #B73601',
    color: '#fff',
    fontSize: '1.2vh',
    padding: '0.6vh 1.6vh',
    borderRadius: '50px',
    border: '1px solid rgba(255, 133, 11, 1)',
    fontWeight: 500,
    willChange: 'transform',
    transform: 'translateZ(0)',
  },
  mainHeading: {
    textAlign: 'center',
    // maxHeight: '17vh',
    textShadow: '0px 2px 10px rgba(255, 255, 255, 0.08) !important',
    WebkitTextStrokeWidth: '0.2px !important',
    WebkitTextStrokeColor: '#FFF',
    fontFamily: 'Onest, sans-serif !important',
    fontSize: '6.4vh !important',
    fontStyle: 'normal',
    fontWeight: '600 !important',
    lineHeight: '7vh !important',
    letterSpacing: '-0.36vh',
    marginBottom: '2.4vh !important',
    textRendering: 'optimizeLegibility',
    background: 'linear-gradient(135deg, #ffffff 30%, rgba(200, 200, 200, 0.6) 100%)',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    [theme.breakpoints.down('md')]: {
      maxHeight: '20vh !important',
      fontSize: '5.2vh !important',
      lineHeight: '5.5vh !important',
      background: 'linear-gradient(135deg, #ffffff 30%, rgba(200, 200, 200, 0.6) 100%)',
      backgroundClip: 'text',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
    },
  },
  subtext: {
    textAlign: 'center',
    fontFamily: '"Plus Jakarta Sans", sans-serif',
    fontSize: '1.8vh',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '2.5vh !important',
    marginBottom: '2vh !important',
    maxWidth: '650px',
    textRendering: 'optimizeLegibility',
    background: 'linear-gradient(180deg, #EAEAEA 0%, rgba(234, 234, 234, 0.00) 321.67%)',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    [theme.breakpoints.down('md')]: {
      fontSize: '1.4vh',
      lineHeight: '2vh !important',
      width: '60%',
    },
  },
  ctaBtn: {
    display: 'flex',
    background: 'linear-gradient(180deg, rgba(55, 38, 18, 0.00) -175%, rgba(255, 133, 11, 0.50) 140%), #B73601',
    backgroundColor: 'rgba(183, 54, 1, 1) !important',
    padding: '0.8vh 2vh !important',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '0.8vh',
    fontSize: '1.4vh !important',
    borderRadius: '1.2vh !important',
    border: '1px solid #FFF',
    boxShadow: '0px 1px 2px 0px #FA854D, 0px 0px 0px 3px rgba(255, 181, 114, 0.16)',
    color: 'rgba(255, 255, 255, 1) !important',
    willChange: 'transform',
    transform: 'translateZ(0)',
    transition: 'transform 0.2s ease',
    cursor: 'pointer',
    // '&:hover': {
    //   transform: 'translateZ(0) scale(1.05)',
    // },

    [theme.breakpoints.down('lg')]: {
      padding: '0.8vh 1.2vh !important',
      fontSize: '1.2vh !important',
      borderRadius: '1.4vh !important',
    },
  },
  heroImageWrapper: {
    background: 'linear-gradient(101deg, rgba(114, 54, 51, 0.40) 5.69%, rgba(63, 100, 32, 0.40) 97.73%)',
    borderRadius: '12px',
    border: '1px solid #721E1E',
    overflow: 'hidden',
    padding: '1vh',
    willChange: 'transform',
    transform: 'translateZ(0)',
    contain: 'layout style paint',
    marginTop: '40px',
  },
  heroImage: {
    width: '100%',
    objectFit: 'cover',
    borderRadius: '12px',
    [theme.breakpoints.up('md')]: {
      height: '33vh',
    },
  },
}));
